module.exports = __webpack_public_path__ + "static/media/bottom-feeder.1df6ce28.png";